<template>
  <Layout>
    <div class="banner-page">
      <img :src="'/img/program-banner.jpg'" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <router-link :to="`/`">Beranda</router-link>
          </li>
          <li>
            <router-link
              :to="
                `/donasi-baju-baru/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu`
              "
              >Ayo, Wujudkan! Baju Baru untuk 1000 Yatim Piatu</router-link
            >
          </li>
          <li>
            <span>Pembayaran</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section pembayaran">
      <div class="container">
        <div class="main-content bg-white">
          <form @submit.prevent="submit" class="standar-form">
            <h5 class="text-title">Donasi Untuk {{ fashionTitle }}</h5>
            <div
              class="form-group"
              :class="{ 'form-group--error': $v.nominal.$error }"
            >
              <label for="email">Nominal Donasi</label>
              <vue-numeric
                placeholder="Masukan Nominal"
                class="form-control"
                currency="Rp."
                separator="."
                v-model="$v.nominal.$model"
                v-int
              ></vue-numeric>
              <div
                class="error"
                v-if="$v.nominal.$dirty && !$v.nominal.cantZeroValue"
              >
                Nominal tidak boleh <strong>Kosong</strong> atau
                <strong>0</strong>
              </div>
              <div
                class="error"
                v-if="$v.nominal.$dirty && !$v.nominal.minimalDonation"
              >
                Minimal Donasi <strong>Rp. 50.000</strong>
              </div>
            </div>

            <div class="spacer"></div>

            <div class="form-group">
              <div class="form-nominal">
                <div
                  class="nominal-wrapper"
                  :class="{ 'is-picked': nominal === 50000 }"
                  @click="setNominal(50000)"
                >
                  <div class="nominal">Rp. 50.000</div>
                </div>
                <div
                  class="nominal-wrapper"
                  :class="{ 'is-picked': nominal === 100000 }"
                  @click="setNominal(100000)"
                >
                  <div class="nominal">Rp. 100.000</div>
                </div>
                <div
                  class="nominal-wrapper"
                  :class="{ 'is-picked': nominal === 150000 }"
                  @click="setNominal(150000)"
                >
                  <div class="nominal">Rp. 150.000</div>
                </div>
                <div
                  class="nominal-wrapper"
                  :class="{ 'is-picked': nominal === 200000 }"
                  @click="setNominal(200000)"
                >
                  <div class="nominal">Rp. 200.000</div>
                </div>
              </div>
            </div>

            <div class="spacer"></div>

            <!-- <div
              class="form-group"
              :class="{ 'form-group--error': $v.name.$error }"
            >
              <label for="name">Nama Anda</label>
              <input
                type="text"
                class="form-control"
                placeholder="Nama Anda"
                v-model="name"
              />
              <div class="error" v-if="$v.name.$dirty && !$v.name.required">
                Nama anda harus diisi
              </div>
              <div class="display_anonym">
                <label>
                  <input type="checkbox" name="tampilkansebagai" />
                  Tampilkan sebagai Hamba Allah
                </label>
              </div>
            </div> -->

            <!-- <div class="spacer"></div>

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.email.$error }"
            >
              <label for="email">E-Mail Anda</label>
              <input
                type="text"
                class="form-control"
                placeholder="Masukan Email Anda"
                v-model="email"
              />
              <div class="error" v-if="$v.email.$dirty && !$v.email.required">
                Email anda harus diisi
              </div>
              <div class="error" v-if="$v.email.$dirty && !$v.email.email">
                Format email anda salah
              </div>
            </div> -->

            <!-- <div class="spacer"></div>

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.telepon.$error }"
            >
              <label for="email">Telepon</label>
              <input
                type="text"
                class="form-control"
                placeholder="Nomor Telepon Anda"
                v-model="telepon"
                v-int
              />
              <div
                class="error"
                v-if="$v.telepon.$dirty && !$v.telepon.required"
              >
                telepon anda harus diisi
              </div>
            </div>

            <div class="spacer"></div>

            <div class="form-group">
              <label for="email">Do'a Anda</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Tulis Do'a terbaik Anda"
                v-model="doa"
              ></textarea>
            </div> -->

            <div class="spacer"></div>

            <div class="form-group">
              <button type="submit" class="btn btn-cta btn-full mt-1">
                Lanjutkan
              </button>
            </div>
          </form>
          <div class="spacer"></div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from '../../views/layouts/Index.vue';

import { required, email } from 'vuelidate/lib/validators';
import VueNumeric from 'vue-numeric';
import { mapActions, mapState } from 'vuex';

const cantZeroValue = (value) => {
  if (value > 0) {
    return true;
  }
  return false;
};

const minimalDonation = (value) => {
  if (value >= 50000) {
    return true;
  }
  return false;
};

export default {
  components: { Layout, VueNumeric },
  name: 'danai',
  data() {
    return {
      data: [],
      nominal: 50000,
      name: '',
      nameAlias: '',
      email: '',
      telepon: '',
      doa: '',
      submitStatus: null,
      anonym: false,
    };
  },
  validations: {
    nominal: {
      cantZeroValue,
      minimalDonation,
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initializeForm();
  },
  computed: {
    ...mapState('transactions', [
      'programId',
      'programTitle',
      'nominalDonasi',
      'userData',
      'fashionId',
      'fashionTitle',
    ]),
  },
  methods: {
    ...mapActions('transactions', [
      'setInitialTransactionFashion',
      'resetForm',
    ]),
    checked: function() {},
    initializeForm() {
      this.nominal = this.nominalDonasi || 50000;
      this.name = this.userData?.namaDonatur || '';
      this.email = this.userData?.emailDonatur || '';
      this.telepon = this.userData?.teleponDonatur || '';
      this.doa = this.userData?.doaDonatur || '';
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        const payload = {
          program: {
            nominalDonasi: this.nominal,
          },
          user: {
            namaDonatur: "Hamba Allah",
            emailDonatur: "deddy@dompetdhuafa.org",
            teleponDonatur: "081212121313",
            doaDonatur: "Semoga berkah, aamiin.",
          },
        };

        this.setInitialTransactionFashion(payload);

        this.$router.push({ name: 'pembayaran-baju-baru' });
      }
    },
    setNominal(val) {
      this.nominal = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/views/scss/payment-pick-nominal';

.text-title {
  font-size: 14px;
  text-align: center;
  padding: 0px 0px 20px 0px;
}
</style>
